export const LOAD_MORE_ITEMS_LIMIT = 3;
export const TRANSITION_TIME_MAX = 400;
export const TRANSITION_TIME_MIN = 100;
export const SHADOW_OVERLAY = 20;

export const MOCK_DIV = {
  scrollLeft: 0,
  clientWidth: 0,
} as HTMLDivElement;
